import CreatePostModal from './CreatePostModal';

export default CreatePostModal;
